import HttpService from '../../core/services/HttpService';
import HttpCallConfig from '../../core/models/HttpCallConfig';
import Notification from '../models/Notification';

const httpService = HttpService.Instance;

async function handlePossibleAPIErrors(response: Response) {
  if (response.ok) {
    return;
  }

  let body;
  try {
    body = await response.json();
  } catch {
    /* @ts-ignore */
  }

  if (body && body.error) {
    throw new Error(body.error);
  }
  throw new Error(response.statusText);
}

class NotificationMgmtService {
  public static async GetNotifications(assetId: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + `notifications?assetId=${assetId}`
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async GetNotificationTypesForAsset(assetId: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + `notificationtypes?assetId=${assetId}`
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async GetNotificationById(id: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + `notifications/${id}`
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async PostNotification(
    assetId: string,
    notification: Notification,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.post(
      process.env.REACT_APP_API_URL + `notifications?assetId=${assetId}`,
      notification,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }

  public static async PutNotification(
    id: string,
    notification: Notification,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.put(
      process.env.REACT_APP_API_URL + `notifications/${id}`,
      notification,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }

  public static async DeleteNotification(
    id: string,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.delete(
      process.env.REACT_APP_API_URL + `notifications/${id}`,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }
}

export default NotificationMgmtService;



// WEBPACK FOOTER //
// ./src/modules/consumer/services/NotificationMgmtService.tsx